export default __webpack_public_path__ + "static/media/twisted_wares.b727bf3a.JPG";